export default __webpack_public_path__ + "b0087faf5e59a58446ac67d89f9f082e.png";